module.exports = __webpack_public_path__ + "img/instagram-food-button-3.81a0d67c.png";